
import * as handlebars_family from "../handlebars_family.ts";
import "../comments/comment.mustache";
import "../comments/comments-widget.ts";
const TPL = handlebars_family.addTemplate("comments/commentsandco",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"fw-comments-opener\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.viewAllComments",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":138},"end":{"line":1,"column":174}}})) != null ? stack1 : "")
    + "</div> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"comments/comment"),depth0,{"name":"comments/comment","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img title=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" class=\"fw-avatar fw-avatar-sizeM\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumb") : depth0), depth0))
    + "\"/>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<flexcol data-widget=\"comments/comments-widget\" style=\"gap:var(--space);\"> "
    + ((stack1 = (lookupProperty(helpers,"if-more")||(depth0 && lookupProperty(depth0,"if-more"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"comments") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),2,{"name":"if-more","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":75},"end":{"line":1,"column":193}}})) != null ? stack1 : "")
    + " <flexcol class=\"fw-comments-container\" style=\"gap:var(--space);\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"comments") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":260},"end":{"line":1,"column":310}}})) != null ? stack1 : "")
    + " </flexcol><flexrow style=\"gap:var(--space);align-items: flex-start;color:#808080\"> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"user") || (depth0 != null ? lookupProperty(depth0,"user") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"user","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":394},"end":{"line":1,"column":489}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"user")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " <form style=\"flex:1\"><input type=\"text\" value=\"\" style=\"width:100%;height:36px;\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"placeholders.comment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":584},"end":{"line":1,"column":617}}})) != null ? stack1 : "")
    + "\" aria-label=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"placeholders.comment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":631},"end":{"line":1,"column":664}}})) != null ? stack1 : "")
    + "\"/></form></flexrow></div> ";
},"usePartial":true,"useData":true});
export default TPL;